"use client";

import isEmpty from "lodash/isEmpty";

import { VcardContent, VcardHeader } from "./components";
import { PreviewSocialNetworks } from "@/features/previews/shared/components/PreviewSocialNetworks";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useVcardData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { handleDownloadVCard } from "./utils";

import "./VcardTemplate.scss";

export const VcardTemplate = (props: QRProps<"vcard">) => {
  const {
    translations,
    isInitialPreview,
    data,
    address,
    fullAddress,
    addressMapsURL,
    vcardFileData,
  } = useVcardData(props);
  if (!data) {
    return null;
  }
  const addressData = {
    address,
    fullAddress,
    addressMapsURL,
  };
  const { summary, socialNetworks } = data;

  return (
    <PhoneLayout
      page="vcard"
      dataQA="preview-vcard-container"
      backgroundColor={"white"}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="vcard-template">
        <VcardHeader
          data={data}
          translations={translations}
          onDownloadClick={() => handleDownloadVCard(vcardFileData)}
          isInitialPreview={isInitialPreview ?? false}
        />
        <VcardContent
          data={data}
          translations={translations}
          addressData={addressData}
          isInitialPreview={isInitialPreview ?? false}
        />
        {summary && <div className="vcard-template__summary-container">{summary}</div>}
        {!isEmpty(socialNetworks) && (
          <div className="qr-content">
            <PreviewSocialNetworks
              networks={socialNetworks}
              variant="business"
              className="business-socialNetworks"
            />
          </div>
        )}
      </div>
    </PhoneLayout>
  );
};
